import {Component, OnInit, ViewChild} from '@angular/core';
import {Resource} from '../../../model/Resource';
import {Constant} from '../../../../global/util/Constant';
import {VerifierService} from '../../../service/verifier.service';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Traceability} from '../../../model/Traceability';
import {DocumentState} from '../../../../global/util/DocumentState';
import {InformType} from '../../../../global/util/enum/InformType';
import HttpStatusCode from '../../../../global/util/HttpStatusCode';
import {ApplicationService} from '../../../service/application.service';
import {Router} from '@angular/router';
import {TraceabilityType} from '../../../../global/util/TraceabilityType';
import {DocumentService} from '../../../service/document.service';
import {Dialog} from '../../../../global/util/Dialog';
import {Operator} from '../../../model/Operator';
import {TypeSignature} from '../../../../global/util/TypeSignature';
import {OperationType} from '../../../../global/util/OperationType';
import {
  CertificateDetailComponent
} from '../../../../public/components/certificate-detail/certificate-detail.component';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-view-document',
  templateUrl: './view-document.component.html',
  styleUrls: ['./view-document.component.css']
})
export class ViewDocumentComponent implements OnInit {

  public title = 'TITLE.DOCUMENT-VIEWER';
  public urlStream;
  public document: any;
  public resources: Resource[];
  public loading: boolean;
  public loadingOperators: boolean;
  public loadingTraceability: boolean;
  public loadingUpdateTraceability: boolean;
  public operatorsInfo: any[] = [];
  public traceabilities: Traceability[];
  public TRACEABILITY_SIGNATURE_COMPONENT = TraceabilityType.SIGNATURE_COMPONENT;
  public TRACEABILITY_VISUALIZACION = TraceabilityType.VISUALIZACION;
  public TRACEABILITY_MAILING = TraceabilityType.MAILING;
  private tracebilitytypes: number[] = [];
  private counterLoadFile = 1;
  public verificationUnavailable = false;
  public resource: Resource;
  @ViewChild('pdfViewer') public pdfViewer;
  public reloadingPdf = false;
  public hasSignature = false;

  constructor(private verifierService: VerifierService,
              private activeModal: NgbActiveModal,
              private modalService: NgbModal,
              private applicationService: ApplicationService,
              private router: Router,
              private documentService: DocumentService,
              private translate: TranslateService) {
    Dialog.createInstance(modalService);
    this.tracebilitytypes.push(TraceabilityType.BASIC);
  }

  ngOnInit(): void {
    this.loadTraceabilitiesBy();
    this.setDefaultValues();
  }

  public accept() {
    this.activeModal.close(InformType.Anything);
  }

  private setDefaultValues() {
    this.resources = this.document._more.resources;
    this.resource = this.document._more.resources[0];
    this.selectAttachment(this.resource);
  }

  public selectAttachment(resource: Resource) {
    this.loadResourceInfo(resource);
  }

  private loadOperators(resource: Resource) {
    const hashIdentifier = this.document.hashIdentifier;
    const hashResource = resource.hashResource;
    let urlVerifierOperators;
    if (Constant.FIRST_OPERATOR === this.document._more.orderNextSigner) {
      if (this.hasSignature) {
        urlVerifierOperators = Constant.ROOT_API_V1.concat('/documents/')
          .concat(hashIdentifier)
          .concat('/private/verifier/initial');
      }
      this.urlStream = Constant.ROOT_API_V1.concat('/public/documents/',
        String(this.document.id),
        '/',
        this.document.hashIdentifier,
        '/resources/',
        String(resource.orderResource),
        '/private/stream/traceability');
    } else if (hashResource) {
      urlVerifierOperators = Constant.ROOT_API_V1.concat('/documents/')
        .concat(hashIdentifier)
        .concat('/resources/')
        .concat(hashResource)
        .concat('/private/verifier');
      this.urlStream = Constant.ROOT_API_V1.concat('/public/documents/')
        .concat(hashIdentifier)
        .concat('/resources/')
        .concat(hashResource)
        .concat('/private/stream');
    } else {
      urlVerifierOperators = Constant.ROOT_API_V1.concat('/documents/')
        .concat(hashIdentifier)
        .concat('/private/verifier');
      this.urlStream = Constant.ROOT_API_V1.concat('/public/documents/')
        .concat(hashIdentifier)
        .concat('/stream');
    }
    this.reloadPdfViewer();
    if (urlVerifierOperators) {
      this.loadOperatorsInfo(urlVerifierOperators);
    }
  }

  private loadResourceInfo(resource: Resource) {
    this.loading = true;
    const url = Constant.ROOT_API_V1.concat('/resources/', String(resource.id), '/moreInfo');
    this.verifierService.get(url).subscribe((next: any) => {
      this.loading = false;
      this.hasSignature = next.hasSignature;
      this.loadOperators(resource);
    }, error => {
      this.loading = false;
      this.processError(this.translate.instant('TITLE.DOCUMENT-VIEWER'), error);
    });
  }

  private loadOperatorsInfo(url: string): void {
    this.loadingOperators = true;
    this.verifierService.get(url).subscribe((next: any) => {
      this.loadingOperators = false;
      this.operatorsInfo = next._embedded.operatorsInfo;
    }, error => {
      this.loadingOperators = false;
      this.operatorsInfo = [];
      this.processError(this.translate.instant('TITLE.DOCUMENT-VIEWER'), error);
    });
  }

  private reloadPdfViewer(): void {
    this.reloadingPdf = true;
    const interval = setTimeout(() => {
      this.reloadingPdf = false;
    }, 300);
  }

  public loadComplete(event) {
    this.loading = false;
    if (Constant.FIRST_OPERATION === this.counterLoadFile) {
      this.updateTraceability();
    }
    this.counterLoadFile++;
  }

  private updateTraceability() {
    this.loadingUpdateTraceability = true;
    const url = Constant.ROOT_API_V1.concat('/documents/', this.document.id, '/traceability/', String(TraceabilityType.VISUALIZACION), '/states/', String(DocumentState.VISUALIZED));
    this.documentService.postTraceability(url).subscribe(() => {
      this.loadingUpdateTraceability = false;
    }, error => {
      this.loadingUpdateTraceability = false;
      const title = this.translate.instant('TITLE.TRACEABILITY');
      this.processError(title, error);
    });
  }

  public getBadgeClassBy(stateId: number): string {
    switch (stateId) {
      case DocumentState.PENDING:
        return 'badge-info';
      case DocumentState.SIGNED:
        return 'badge-success';
      case DocumentState.REVIEWED:
        return 'badge-primary';
      case DocumentState.OBSERVED:
        return 'badge-warning';
      case DocumentState.FINISHED:
        return 'badge-dark';
      case DocumentState.DELIVERED:
        return 'custom-badge-delivered';
      case DocumentState.ATTENDED:
        return 'custom-badge-attended';
      case DocumentState.DOWNLOADED:
        return 'custom-badge-downloaded';
      case DocumentState.CANCELED:
        return 'badge-danger';
      case DocumentState.MODIFIED:
        return 'custom-badge-modified';
      case DocumentState.PENDING_MODIFICATION:
        return 'custom-badge-modified';
      case DocumentState.VISUALIZED:
        return 'custom-badge-visualized';
      case DocumentState.SCHEDULE_ATTACH_DELIVERY:
        return 'custom-badge-schedule-attach-delivery';
      case DocumentState.ATTACH_SENT:
        return 'custom-badge-attach-sent';
      case DocumentState.ERROR_SENDING_ATTACH:
        return 'custom-badge-error-sending-attach';
      case DocumentState.ES_GRAPHIC_SIGNATURE:
        return 'badge-secondary';
      case DocumentState.DS_CLOUD_SIGNATURE:
        return 'badge-success';
      case DocumentState.CODE_SENT:
        return 'badge-secondary';
      case DocumentState.CONTRACT_DOWNLOADED:
        return 'custom-badge-downloaded';
      case DocumentState.INCORRECT_IDENTITY_VALIDATION:
        return 'badge-warning';
      case DocumentState.CORRECT_IDENTITY_VALIDATION:
        return 'custom-badge-downloaded';
      case DocumentState.PRE_CERTIFICATE_ONE_SIGN:
        return 'custom-badge-downloaded';
      default:
        break;
    }
  }

  private processError(title: string, error: any) {
    const status = error.status;
    if (status) {
      if (HttpStatusCode.UNAUTHORIZED === status) {
        Dialog.show(InformType.Danger, title, error.error.message);
      } else if (HttpStatusCode.FORBIDDEN === status) {
        Dialog.show(InformType.Info, this.translate.instant('TITLE.SESSION-EXPIRED'), this.translate.instant('MESSAGE.SESSION-EXPIRED'));
        this.logout();
      } else if (HttpStatusCode.SERVICE_UNAVAILABLE === status) {
        this.verificationUnavailable = true;
        Dialog.show(InformType.Danger, title, error.error.message, 160);
      } else {
        Dialog.show(InformType.Danger, title);
      }
    } else {
      Dialog.show(InformType.Danger, title, error.error.message);
    }
  }

  private logout() {
    this.applicationService.setUserLoggedIn(false);
    this.router.navigate(['login']);
  }

  get hasOperators(): boolean {
    return this.operatorsInfo.length > Constant.MINIMUM_OPERATOR;
  }

  public onItemChangeTraceability(event, traceabilityType: number) {
    switch (traceabilityType) {
      case TraceabilityType.SIGNATURE_COMPONENT:
        if (event.target.checked) {
          this.tracebilitytypes.push(TraceabilityType.SIGNATURE_COMPONENT);
        } else {
          const index = this.tracebilitytypes.findIndex(value => value === TraceabilityType.SIGNATURE_COMPONENT);
          this.tracebilitytypes.splice(index, 1);
        }
        break;
      case TraceabilityType.VISUALIZACION:
        if (event.target.checked) {
          this.tracebilitytypes.push(TraceabilityType.VISUALIZACION);
        } else {
          const index = this.tracebilitytypes.findIndex(value => value === TraceabilityType.VISUALIZACION);
          this.tracebilitytypes.splice(index, 1);
        }
        break;
      case TraceabilityType.MAILING:
        if (event.target.checked) {
          this.tracebilitytypes.push(TraceabilityType.MAILING);
        } else {
          const index = this.tracebilitytypes.findIndex(value => value === TraceabilityType.MAILING);
          this.tracebilitytypes.splice(index, 1);
        }
        break;
    }
    this.loadTraceabilitiesBy();
  }

  public loadTraceabilitiesBy() {
    const types = this.tracebilitytypes.join(',');
    this.loadingTraceability = true;
    const url = Constant.ROOT_API_V1.concat('/documents/', this.document.id, '/traceability?types=', types);
    this.documentService.get(url).subscribe((next: any) => {
      this.loadingTraceability = false;
      this.traceabilities = next._embedded.documenttraceabilities;
    }, error => {
      this.loadingTraceability = false;
      const title = this.translate.instant('TITLE.VIEW-TRACEABILITY');
      this.processError(title, error);
    });
  }

  public getClassOperatorInfo(operatorInfo: Operator): string {
    if (Constant.CORRECT_OPERATION === operatorInfo.correctOperation) {
      if (Constant.OLD_SIGNATURE === operatorInfo.isOldSignature) {
        return 'fa-exclamation-circle custom-icon-alert';
      } else {
        switch (operatorInfo.operationId) {
          case Constant.SIGN_OPTION:
            if (TypeSignature.DIGITAL === operatorInfo.typeSignature) {
              return 'fa-file-signature fa-check-circle custom-icon-success';
            } else if (TypeSignature.ELECTRONIC === operatorInfo.typeSignature) {
              return 'fa-signature';
            } else {
              return 'fa-check-circle';
            }
          case Constant.REVIEW_OPTION:
            return 'fa-check-circle custom-icon-primary';
        }
      }
    } else {
      return 'fa-times-circle custom-icon-warn';
    }
  }

  public showModalSignatureInfo(operatorInfo: Operator): void {
    const title = this.translate.instant('TITLE.SIGNATURE-VALIDITY');
    if (Constant.CORRECT_OPERATION === operatorInfo.correctOperation) {
      if (Constant.OLD_SIGNATURE === operatorInfo.isOldSignature) {
        Dialog.show(InformType.Warning, title, this.translate.instant('MESSAGE.DOCUMENT-ALREADY-HAD-SIGNATURE'));
      } else {
        Dialog.show(InformType.Success, title, this.translate.instant('MESSAGE.SIGNATURE-IS-VALID'));
      }
    } else {
      Dialog.show(InformType.Success, title, this.translate.instant('MESSAGE.SIGNATURE-IS-NOT-VALID'));
    }
  }

  public getClassMaxHeight(operatorInfo: Operator[]): string {
    switch (operatorInfo.length) {
      case 0:
        return 'max-height-0';
      case 1:
        return 'max-height-1';
      case 2:
        return 'max-height-2';
      default:
        return 'max-height-3';
    }
  }

  public hasntCertificate(operatorsInfo: any): boolean {
    return OperationType.REVIEW === operatorsInfo.operationId ||
      (TypeSignature.ELECTRONIC === operatorsInfo.typeSignature &&
        !this.hasDocumentIntegrity(operatorsInfo)) ||
      Constant.CORRECT_OPERATION !== operatorsInfo.correctOperation;
  }

  public openModalSeeCertificateDetail(index: number) {
    const modalRef = this.modalService.open(CertificateDetailComponent, {size: 'lg'});
    modalRef.componentInstance.operatorInfo = this.operatorsInfo[index];
    modalRef.componentInstance.resumeHashResource = this.resource.hashResource;
    modalRef.componentInstance.index = index;
    modalRef.componentInstance.haveDocumentIntegrity = this.hasDocumentIntegrity(this.operatorsInfo[index]);
  }

  hasDocumentIntegrity(operatorsInfo: any) {
    return operatorsInfo.documentIntegrity;
  }

  public traceabilitiesisHasMoreThan15(): boolean {
    if (this.traceabilities) {
      return this.traceabilities.length > 15;
    }
  }
}
